module.exports = (Api, $uibModal) ->
  return {
    restrict: 'A'
    scope:
      customSourceModalButtonSource: '&'
      customSourceModalButtonOnOk: '&'
      customSourceModalButtonOnRemove: '&?'
    link: ( scope, element, attrs ) ->
      element.on 'click', ->
        customSourceModalInstance = $uibModal.open
          template: require("./custom-source-modal.html")
          controller: require("./CustomSourceModalController")
          resolve:
            source: () -> angular.copy(scope.customSourceModalButtonSource())
            countries: () -> Api.Country.query().$promise
            canRemove: () -> angular.isDefined( attrs.customSourceModalButtonOnRemove )
          size: "md"
        customSourceModalInstance.result.then ({ action, customSource }) ->
          switch action
            when 'Save' then scope.customSourceModalButtonOnOk({ customSource: customSource })
            when 'Remove' then scope.customSourceModalButtonOnRemove()
  }
